import React from 'react';
import './Badge.css';

/**
 * Badge / Chip (기획서 §8.4)
 * variants: neutral | primary | success | warning | error | dark | light
 */
const Badge = ({ variant = 'neutral', size = 'md', children, className = '', ...rest }) => {
  const cls = [
    'ft-badge',
    `ft-badge--${variant}`,
    `ft-badge--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
};

export default Badge;
